import React from 'react';
import styled from 'styled-components';

import { FaBolt } from 'react-icons/fa';


const Container = styled.div`
    display: grid;
    grid-template-columns: 3rem 1fr;
    height: 3rem;
    grid-column-gap: 0.5rem;
`

const Icon = styled.div`
    background-color: ${props => props.backgroundColor || 'var(--primary-color)'};
    border-radius: 5px;
    padding: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Title = styled.div`
    font-weight: bold;
    font-size: 1.3rem;
    /* align-self: start; */
`

const Subtitle = styled.div`
    font-weight: bold;
    font-size: 0.9rem;
    /* align-self: end; */
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
`

const Header = props => {
    const {
        icon,
        subtitle,
        title
    } = props;

    // <img src={SubmarkLogo} style={{width:'auto', height:'1.5rem',objectFit:'contain', cursor: 'pointer'}} onClick={() => history.push('/')}/>

    return (
        <Container>
            <Icon backgroundColor={props.iconBackgroundColor}>{icon || <FaBolt style={{fontSize: '1.5rem'}}/>}</Icon>
            <Wrapper>
                <Subtitle>{subtitle}</Subtitle>
                <Title>{title}</Title>
            </Wrapper>
        </Container>
    )
}

export default Header;